import React, { useState } from 'react';

const MarketNewsPanel = ({ marketNews, portfolioNews = [] }) => {
  const [viewMode, setViewMode] = useState('market'); // 'market' or 'portfolio'
  
  // Use appropriate news based on view mode - fill the panel with news
  const displayNews = viewMode === 'market' 
    ? (marketNews || []).slice(0, 14)
    : (portfolioNews || []).slice(0, 14);
  
  return (
    <div className="absolute right-2 top-44 bottom-12 w-56 bg-slate-800/90 backdrop-blur-sm rounded-lg border border-slate-700 overflow-hidden flex flex-col max-sm:relative max-sm:inset-auto max-sm:w-full max-sm:h-[40vh]">
      {/* Header with Toggle */}
      <div className="px-2 py-1.5 bg-slate-900/50 border-b border-slate-700 shrink-0">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-[10px] font-bold text-slate-300 uppercase tracking-wide">📰 Market News</h3>
        </div>
        {/* Toggle Buttons */}
        <div className="flex bg-slate-700/50 rounded p-0.5">
          <button
            onClick={() => setViewMode('market')}
            className={`flex-1 text-[9px] font-medium py-0.5 px-2 rounded transition-all ${
              viewMode === 'market'
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            Market
          </button>
          <button
            onClick={() => setViewMode('portfolio')}
            className={`flex-1 text-[9px] font-medium py-0.5 px-2 rounded transition-all ${
              viewMode === 'portfolio'
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            My Stocks
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        {displayNews.length > 0 ? (
          displayNews.map((news, i) => (
            <a 
              key={i} 
              href={news.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="block px-2 py-1.5 border-b border-slate-700/30 hover:bg-slate-700/50 transition-colors"
            >
              {viewMode === 'portfolio' && news.symbol && (
                <span className="text-[9px] font-bold text-blue-400 mr-1">
                  ${news.symbol}
                </span>
              )}
              <p className="text-[11px] font-medium text-slate-200 line-clamp-2 leading-tight">{news.headline}</p>
              <p className="text-[9px] text-slate-500 mt-0.5">{news.source}</p>
            </a>
          ))
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-xs text-slate-500 text-center px-4">
              {viewMode === 'portfolio' ? 'Loading news for your stocks...' : 'Loading news...'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarketNewsPanel;
